module.exports = __webpack_public_path__ + "img/16.c827f7f8.jpg";